export default __webpack_public_path__ + "static/gilroy-semibold-5f6b8a466d1d7a3f735970c451ecd9b8.eot";